import { useState } from "react";
import { Link } from "react-router-dom";
import BuyButton from "@/components/BuyButton";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Real purchase button for a catalog item. When the owner has set a price,
 * this is a live Stripe checkout button. Until then it stays fully wired but
 * explains pricing is being finalized instead of inventing a number.
 */
const BuyOrNotify = ({ lookupKey, price, label, testId, className = "" }) => {
  const [open, setOpen] = useState(false);

  if (price != null) {
    return (
      <BuyButton lookupKey={lookupKey} testId={testId} className={className}>
        {label}
      </BuyButton>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2 focus:ring-offset-cream ${className}`}
      >
        {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-cream sm:max-w-md" data-testid={`${testId}-dialog`}>
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl text-ink">Pricing coming soon</DialogTitle>
            <DialogDescription className="text-lg leading-relaxed text-ink/75 pt-2">
              The price for this deck has not been set yet. Send us a message and we will let you know
              the moment it is available to order.
            </DialogDescription>
          </DialogHeader>
          <Link
            to="/contact"
            data-testid={`${testId}-contact-link`}
            className="inline-flex items-center justify-center bg-sage text-white hover:bg-sage-dark rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 mt-2"
          >
            Contact Us
          </Link>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BuyOrNotify;
